import { api } from '../api';
import type { BalancaDoEnsaio } from './triviais';

/**
 * As chamadas da granulometria, com os caminhos escritos por extenso.
 *
 * Mesmo motivo dos outros: o caminho é o contrato entre a tela e a API, e
 * contrato se lê. O teste `26` — que confere se toda rota de criação tem
 * caminho na interface — precisa enxergar a string literal.
 */

export interface EnsaioGranulometria {
  cabecalho: any;
  peneiras: any[];
  umidades: any[];
  serie: any[];
  equipamentos: any[];
  /** As leituras do densímetro com o que a 0221 calcula de cada uma. */
  sedimentacao: any[];
  /** A balança da amostra total (Mt) e do peneiramento grosso (RN-215, 0222). */
  balanca: BalancaDoEnsaio | null;
  /** A balança da amostra parcial (Mu) e do peneiramento fino (0222). */
  balancaFina: BalancaDoEnsaio | null;
  /** A balança das cápsulas da umidade higroscópica (0222). */
  balancaUmidade: BalancaDoEnsaio | null;
  pendencias: string[];
  pendenciasDetalhadas?: any[];
  /** A tentativa da repetição aberta, se houver (onda 323). */
  repeticaoAberta?: number | null;
}

export const verGranulometria = (id: string) =>
  api<EnsaioGranulometria>(`/ensaios/${id}/granulometria`);

export const gravarGranulometriaCabecalho = (id: string, corpo: unknown) =>
  api<EnsaioGranulometria>(`/ensaios/${id}/granulometria`,
    { metodo: 'PUT', corpo });

export const gravarGranulometriaPeneiras = (id: string, corpo: unknown) =>
  api<EnsaioGranulometria>(`/ensaios/${id}/granulometria/peneiras`,
    { metodo: 'POST', corpo });

export const gravarGranulometriaUmidades = (id: string, corpo: unknown) =>
  api<EnsaioGranulometria>(`/ensaios/${id}/granulometria/umidades`,
    { metodo: 'POST', corpo });

export const descartarGranulometriaUmidade = (
  id: string, uid: string, motivo: string,
) =>
  api<EnsaioGranulometria>(
    `/ensaios/${id}/granulometria/umidades/${uid}/descartar`,
    { metodo: 'POST', corpo: { motivo } });

export const gravarGranulometriaSedimentacao = (id: string, corpo: unknown) =>
  api<EnsaioGranulometria>(`/ensaios/${id}/granulometria/sedimentacao`,
    { metodo: 'POST', corpo });

export const descartarGranulometriaLeitura = (
  id: string, sid: string, motivo: string,
) =>
  api<EnsaioGranulometria>(
    `/ensaios/${id}/granulometria/sedimentacao/${sid}/descartar`,
    { metodo: 'POST', corpo: { motivo } });
